import React,{useState} from 'react'
import {Redirect} from 'react-router-dom';


const Info_location = (props) => {
    const initialStateValues = {
        address: "",
        additional_notes_address: "",
        redirectToHome: false
      };
    const [values, setValues] = useState(initialStateValues);
    
    const handleInputChange = e =>{
        const {name,value} = e.target;
        setValues({...values,[name]: value})
        var f = document.forms["theform"].elements;
        var cansubmit = true;
 
        for (var i = 0; i < f.length; i++) {
            if (f[i].value.length === 0) cansubmit = false;
        }
 
        if (cansubmit) {
            document.getElementById('submitbutton').disabled = false;
        }
        else {
            document.getElementById('submitbutton').disabled = 'disabled';
        }
      }
     
      const hundleSubmit = e =>{
        e.preventDefault();
        sessionStorage.setItem('info_address', values.address);
        sessionStorage.setItem('info_additional_location', values.additional_notes_address);
        setValues({
          redirectToHome: true
        })
      };
    return(
        <div className="contenedor  mx-auto text-center">
          { values.redirectToHome ? (<Redirect push to="/time"/>) : null }
             <form name="theform" onSubmit={hundleSubmit} className="mt-3">
             <div className="form-group">
             <label className="lblSize">Address</label>
                <input 
                  name="address" 
                  onChange={handleInputChange}
                  value={values.address || ''} 
                  type="text" 
                  />
              </div>
              <div className="form-group">
              <label className="lblSize">Additional notes</label>
              <textarea
              name="additional_notes_address"
              onChange={handleInputChange} 
              value={values.additional_notes_address || ''} 
              id="exampleFormControlTextarea1" 
              
              />
              </div>
                    <div className="mt-5">
                    <button id="submitbutton" type="submit" disabled="disabled" value="Submit"  className="btn btn-secondary mx-auto mt-5"> Continue </button>
                    </div>
            </form>
        </div>
    )
}

export default Info_location